const selectors = {
  wrapper: '[data-quantity-selector]',
  increase: '[data-increase-quantity]',
  decrease: '[data-decrease-quantity]',
  input: '[data-quantity-input]',
};

class Quantity {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.increase = this.wrapper.querySelector(selectors.increase);
    this.decrease = this.wrapper.querySelector(selectors.decrease);
    this.input = this.wrapper.querySelector(selectors.input);
    this.min = parseInt(this.input.getAttribute('min'), 10);
    this.initButtons();
  }

  initButtons() {
    this.increase.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        let v = parseInt(this.input.value, 10);
        v = isNaN(v) ? 0 : v;
        v++;
        this.input.value = v;
        this.input.dispatchEvent(new Event('change'));
      }.bind(this)
    );
    this.decrease.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        let v = parseInt(this.input.value, 10);
        v = isNaN(v) ? 0 : v;
        v--;
        v = Math.max(this.min, v);
        this.input.value = v;
        this.input.dispatchEvent(new Event('change'));
      }.bind(this)
    );
  }
}

function initQtySection(container) {
  const quantityWrappers = container.querySelectorAll(selectors.wrapper);
  quantityWrappers.forEach((qty) => {
    new Quantity(qty);
  });
}

export {initQtySection};
